// Libraries
var React = require('react');

class StrikerLineupStats extends React.Component {
	render() {
		return (
			<div>
				<div className="LineupPlayer__stats">
					{!isNaN(this.props.MinutesPlayed) && this.props.MinutesPlayed > 0 &&
							<div className="LineupPlayer__stat">
								<p className="LineupPlayer__stat--heading">Minutes Played</p>
								<p className="LineupPlayer__stat--value">{this.props.MinutesPlayed}</p>
							</div>
					}

					{!isNaN(this.props.GoalsScored) &&
							<div className="LineupPlayer__stat">
								<p className="LineupPlayer__stat--heading">Goals Scored</p>
								<p className="LineupPlayer__stat--value">{this.props.GoalsScored}</p>
							</div>
					}

					{!isNaN(this.props.Assists) &&
							<div className="LineupPlayer__stat">
								<p className="LineupPlayer__stat--heading">Assists</p>
								<p className="LineupPlayer__stat--value">{this.props.Assists}</p>
							</div>
					}

					{!isNaN(this.props.ShotsTotal) &&
							<div className="LineupPlayer__stat">
								<p className="LineupPlayer__stat--heading">Shots Total</p>
								<p className="LineupPlayer__stat--value">{this.props.ShotsTotal}</p>
							</div>
					}

					{!isNaN(this.props.ShotsOnTarget) &&
							<div className="LineupPlayer__stat">
								<p className="LineupPlayer__stat--heading">Shots On Target</p>
								<p className="LineupPlayer__stat--value">{this.props.ShotsOnTarget}</p>
							</div>
					}

					{!isNaN(this.props.Touches) &&
							<div className="LineupPlayer__stat">
								<p className="LineupPlayer__stat--heading">Touches</p>
								<p className="LineupPlayer__stat--value">{this.props.Touches}</p>
							</div>
					}

					{!isNaN(this.props.YellowCards) && !isNaN(this.props.RedCards) &&
							<div className="LineupPlayer__stat">
								<p className="LineupPlayer__stat--heading">Cards</p>
								<p className="LineupPlayer__stat--value"><span className="yellowcard" aria-label="Number of yellow cards">{this.props.YellowCards}</span> <span className="redcard"  aria-label="Number of red cards">{this.props.RedCards}</span></p>
							</div>
					}
				</div>
			</div>
		)
	}
}

module.exports = StrikerLineupStats;



// WEBPACK FOOTER //
// ./src/components/MDC/Lineup/StrikerLineupStats.js